/* Grid images Slider section
--------------------------------------*/

class BannerSlider {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.slider();
  }

  slider = () => {
    let sliders = qsa('.banner-slider');
    if (sliders.length > 0) {
      sliders.forEach(element => {
        let bannerSliderSectionId = element.dataset.id;
        let bannerSliderPlay = element.dataset.autoplay;
        let bannerSliderSlide = element.dataset.slide;
        let BannerSliderClass = `.banner-slider.${bannerSliderSectionId}`;
        if(qsa(`${BannerSliderClass} .swiper-slide`).length > 1){
          this.BannerSlider(BannerSliderClass, bannerSliderSlide, bannerSliderPlay);
        }
      });
    }
  }
  BannerSlider = (sliderClass, bannerSliderSlide, bannerSliderPlay) => {
    let props = { autoplay: false }
    if (bannerSliderPlay) {
      props = {
        autoplay: {
          delay: 5000
        },
        spaceBetween: 10 
      }
    }

    // Wait for DOM to be fully ready
    setTimeout(() => {
      
      const paginationEl = document.querySelector(`${sliderClass} ~ .swiper-pagination.banner-pagination`);
      const recommendationSlider = new Swiper(sliderClass, {
        ...props,
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        shortSwipes: true,
        shortSwipesRatio: 0,
        speed: 1000,
        resistanceRatio: 0.4,

        // Navigation arrows
        navigation: {
          nextEl: `${sliderClass} .swiper-button-next.banner-arrow`,
          prevEl: `${sliderClass} .swiper-button-prev.banner-arrow`,
        },
        // Pagination dots - only initialize if element exists
        pagination: paginationEl ? {
          el: paginationEl,
          type: 'bullets',
          clickable: true
        } : false,
      });

      // Force update after initialization
      recommendationSlider.update();
    }, 100);
  }

}

new BannerSlider(qs('.banner-slider'));
